export default __webpack_public_path__ + "static/media/img-slider-dlttaxi-4.a5b540cf.png";